/* V4 signup UI only. Shopify handles submission, consent, spam checks and double opt-in. */
(function () {
  'use strict';
  if (window.BMGSignup) { window.BMGSignup.init(); return; }
  const PREFIX = 'bmg-signup-v4:';
  const DAY = 86400000;
  const memory = {};
  const instances = new Map();
  const read = (key, session) => {
    try { return (session ? sessionStorage : localStorage).getItem(PREFIX + key); }
    catch (_) { return memory[key] || null; }
  };
  const write = (key, value, session) => {
    memory[key] = String(value);
    try { (session ? sessionStorage : localStorage).setItem(PREFIX + key, String(value)); } catch (_) {}
  };
  const remove = (key, session) => {
    delete memory[key];
    try { (session ? sessionStorage : localStorage).removeItem(PREFIX + key); } catch (_) {}
  };
  const subscribed = () => Number(read('signed-up-until')) > Date.now();
  const rememberSuccess = () => write('signed-up-until', Date.now() + 365 * DAY);

  function init() {
    document.querySelectorAll('.bmg-signup-form').forEach(form => {
      if (form.dataset.bmgBound) return;
      form.dataset.bmgBound = 'true';
      if (form.querySelector('[data-bmg-signup-success]')) rememberSuccess();
      form.addEventListener('submit', event => {
        if (!form.checkValidity()) { event.preventDefault(); form.reportValidity(); return; }
        // Store identifiers and timing only, never the visitor's email address.
        write('pending-form', form.id, true);
        write('pending-at', Date.now(), true);
        // Do not fake a success state: allow Shopify's native form and captcha to run.
      });
      if (!form.closest('[data-bmg-signup-popup]')) {
        form.addEventListener('input', () => write('inline-started', '1', true), {once:true});
      }
    });

    document.querySelectorAll('[data-bmg-signup-popup]').forEach(dialog => {
      if (instances.has(dialog) || typeof dialog.showModal !== 'function') return;
      const controller = new AbortController();
      const on = (el, event, handler) => el.addEventListener(event, handler, {signal:controller.signal});
      const form = dialog.querySelector('form');
      const days = Math.min(30, Math.max(2, Number(dialog.dataset.delayDays) || 30));
      const delay = Math.min(60, Math.max(2, Number(dialog.dataset.delaySeconds) || 20));
      const editor = dialog.dataset.designMode === 'true';
      const preview = new URL(location.href).searchParams.get('signup_preview') === '1';
      let timer;
      let trigger;
      let opened = false;
      function open(manual) {
        if (dialog.open || !dialog.isConnected) return;
        if (!manual && (opened || subscribed() || Number(read('dismissed-until')) > Date.now() || read('inline-started', true))) return;
        if (!manual && (document.hidden || document.activeElement?.matches('input,textarea,select,[contenteditable=true]') || document.querySelector('dialog[open],.modal--is-active,.drawer--is-open'))) {
          timer = setTimeout(() => open(false), 5000); return;
        }
        const inline = document.querySelector('#collector-list');
        if (!manual && inline) {
          const rect = inline.getBoundingClientRect();
          if (rect.top < innerHeight && rect.bottom > 0) return;
        }
        clearTimeout(timer);
        trigger = document.activeElement;
        dialog.showModal();
        document.documentElement.classList.add('bmg-signup-open');
        opened = true;
        // Focus close first so opening the mobile popup does not summon the keyboard.
        (dialog.querySelector('[data-bmg-signup-error],[data-bmg-signup-success]') || dialog.querySelector('[data-bmg-signup-close]'))?.focus({preventScroll:true});
      }
      function dismiss(remember) {
        clearTimeout(timer);
        if (remember && !editor && !preview) write('dismissed-until', Date.now() + days * DAY);
        if (dialog.open) dialog.close();
      }
      on(dialog.querySelector('[data-bmg-signup-close]'), 'click', () => dismiss(true));
      on(dialog, 'cancel', event => { event.preventDefault(); dismiss(true); });
      let backdropStart = false;
      const outside = event => {
        const rect = dialog.getBoundingClientRect();
        return event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom;
      };
      on(dialog, 'pointerdown', event => { backdropStart = event.target === dialog && outside(event); });
      on(dialog, 'click', event => { if (backdropStart && event.target === dialog && outside(event)) dismiss(true); backdropStart = false; });
      on(dialog, 'close', () => {
        document.documentElement.classList.remove('bmg-signup-open');
        if (trigger?.isConnected && trigger !== document.body) trigger.focus({preventScroll:true});
      });
      on(document, 'click', event => {
        if (event.target.closest('[data-bmg-open-signup]')) { event.preventDefault(); open(true); }
      });
      on(document, 'shopify:section:select', event => {
        if (String(event.detail?.sectionId) === dialog.dataset.sectionId) open(true);
      });
      on(document, 'shopify:section:deselect', event => {
        if (String(event.detail?.sectionId) === dialog.dataset.sectionId) dismiss(false);
      });
      const feedback = dialog.querySelector('[data-bmg-signup-success],[data-bmg-signup-error]');
      const pending = read('pending-form', true) === form?.id && Date.now() - Number(read('pending-at', true)) < 30 * 60000;
      const returning = feedback && (pending || location.hash === '#' + form?.id);
      if (returning || preview) open(true);
      else if (!editor) timer = setTimeout(() => open(false), delay * 1000);
      if (returning) { remove('pending-form', true); remove('pending-at', true); }
      instances.set(dialog, {destroy() { clearTimeout(timer); dismiss(false); controller.abort(); instances.delete(dialog); }});
    });
  }
  window.BMGSignup = {init};
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', event => {
    instances.forEach((instance, dialog) => { if (event.target.contains(dialog)) instance.destroy(); });
  });
})();
